import { fetchQuery } from 'react-relay';
import { getBuyerId } from 'dibs-cookie-jar';

import { privacyPolicyChangeNoticeAction } from './privacyPolicyChangeNoticeAction';
import { privacyPolicyChangeNoticeQuery } from './privacyPolicyChangeNoticeQuery';

import { initialRule, viewerRule } from './privacyPolicyChangeNoticeHelpers';

export const privacyPolicyChangeNoticeRule = ({ relayEnvironment }) => {
    const userId = getBuyerId(document.cookie);

    if (!initialRule(userId)) {
        return Promise.resolve(false);
    }

    return fetchQuery(relayEnvironment, privacyPolicyChangeNoticeQuery, { userId }).then(response =>
        Promise.resolve(viewerRule(response && response.viewer))
    );
};

export const privacyPolicyChangeNoticeConfig = {
    name: 'privacyPolicyChangeNotice',
    rule: privacyPolicyChangeNoticeRule,
    action: privacyPolicyChangeNoticeAction,
    priority: 1,
};
